import PosterImageModel from "./posterImage.model"
import Utils from "../../utils/utils"
import { GradeBandEnum } from "../constants"

export default class CommonCardModel {
    public routerLink: string[] = []
    public gradesDisplay: string = ""
    constructor(
        public brand: string | null,
        public canonicalUrl: string,
        public description: string,
        public grades: string[],
        public posterImages: PosterImageModel[],
        public title: string,
        public type: string
    ) {
        this.routerLink = this.getRouterLink(this.type)
        this.gradesDisplay = CommonCardModel.getGradesDisplay(this.grades)
    }

    public isResource(): boolean {
        return this.type === "resource"
    }

    public isCollection(): boolean {
        return this.type === "collection"
    }

    // all poster images methods were moved here from learning object, atm they are duplicated
    public getPosterImage(width?: number, height?: number, type?: string) {
        let url
        if (type) {
            url = this.getPosterImageIfExists(type, width, height)
            if (url) {
                return url
            }
        }
        url = this.getPosterImageIfExists("original", width, height)
        if (url) {
            return url
        }
        url = this.getPosterImageIfExists("default", width, height)
        if (url) {
            return url
        }
        return null
    }

    public getPosterImageIfExists(type: string, width?: number, height?: number) {
        return Utils.getITSImageIfExists(this.posterImages, type, width, height)
    }

    public getRouterLink(type: string) {
        const isCollection = type === "collection"
        const canonicalURLParts = (this.canonicalUrl || "").split("/").filter((p) => p.length)
        if (canonicalURLParts.length < 2) {
            return ["/"]
        }
        if (isCollection) {
            const slugsPart = (this.canonicalUrl || "").split("/collection/").slice(-1)[0]
            const slugs = slugsPart.split("/").filter((p) => p.length)
            return ["/", "collection"].concat(slugs)
        }

        const resourceURLParts = canonicalURLParts.slice(canonicalURLParts.indexOf("resource") + 1)
        return ["/", "resource"].concat(resourceURLParts)
    }

    public static getGradesDisplay(grades: string[]) {
        if (!grades) {
            return null
        }

        let gradesDisplay: string = ""

        const is13Plus = grades.length === 1 && grades[0] === GradeBandEnum.Band13Plus
        grades = grades.filter((g) => g !== GradeBandEnum.Band13Plus)
        const hasAllGrades =
            [
                GradeBandEnum.Band3to5,
                GradeBandEnum.Band6to8,
                GradeBandEnum.Band9to12,
            ].every((grade) => grades.includes(grade)) &&
            (grades.includes(GradeBandEnum.BandPreKtoK) || grades.includes(GradeBandEnum.BandKto2))

        if (is13Plus) {
            gradesDisplay = null
        } else if (hasAllGrades) {
            gradesDisplay = "All"
        } else {
            gradesDisplay = grades.join(", ")
        }

        return gradesDisplay
    }
}
